import type { VisualPayload } from "../../types";
import CardShell from "./_CardShell";
import CardRenderer from "./CardRenderer";

interface Props { payload: VisualPayload }

export default function CompoundCard({ payload }: Props) {
  const sec = payload.sections.find((s) => s.section === "sub_cards");
  const subCards = (sec?.cards as Array<{ intent: string; card: VisualPayload }>) ?? [];

  return (
    <CardShell title={payload.title} source={payload.data_source} timestamp={payload.data_timestamp} sourceUrl={payload.source_url} shareUrl={payload.share_url} snapshotPayload={payload.snapshot_eligible ? payload : undefined}>
      <div className="space-y-3">
        {subCards.map((sc) => (
          <div key={sc.intent} className="rounded-lg border border-gray-700 overflow-hidden">
            <CardRenderer payload={sc.card} />
          </div>
        ))}
      </div>
    </CardShell>
  );
}
